<template>
  <v-card class="mt-1">
    <v-col cols="12" class="pb-0 pt-1 pl-1" :style="estiloDerechos">
      <v-row justify="space-between" class="pl-2">
        <v-col cols="8" class="pb-1 pt-1">
          <span v-if="numero !== 0" style="font-size: 1rem"> Cuota: {{ numero }} </span>
        </v-col>
        <v-col cols="2" class="pt-0 pb-0">
          <v-checkbox v-if="condonar && saldo !== 0 && !canEdit" v-model="seleccionada" hide-details color="info" class="shrink mr-0 mt-0 pa-0" @change="select" />
        </v-col>
        <v-col v-if="!(saldo === inputVal) && (cuota.monto_condonado === 0)" cols="2" class="pb-1 pt-1">
          <v-tooltip content-class="top" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="mostrarInfoCuota(cuota, cuota.moneda_id)">
                mdi-information-outline
              </v-icon>
            </template>
            <span>Mostrar pagos</span>
          </v-tooltip>
        </v-col>
        <v-col v-else-if="(cuota.monto === cuota.monto_condonado)" cols="2" class="pt-0 pb-0">
          <v-tooltip content-class="top" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on">
                mdi-information-outline
              </v-icon>
            </template>
            <span>Condonada</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-col>
    <v-row class="pl-2 pr-2">
      <v-col cols="12" md="6" class="pb-0 pt-1">
        <v-text-field v-model="inputVal" color="gold" label="Monto" type="number" step="0.01" :prefix="simbolo" :readonly="canEdit" />
      </v-col>
      <v-col cols="12" md="6" class="pb-0 pt-1">
        <v-text-field v-model="saldo" color="gold" label="Saldo" type="number" step="0.01" :prefix="simbolo" readonly />
      </v-col>
    </v-row>
    <v-col cols="12" class="pt-0">
      <v-menu ref="menuVencimiento" v-model="menuVencimiento" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y :disabled="canEdit">
        <template v-slot:activator="{ on }">
          <v-text-field v-model="dateVal" color="gold" label="Vencimiento" readonly v-on="on" />
        </template>
        <v-date-picker v-model="dateVal" prepend-inner-icon="mdi-calendar-outline" color="gold" landscape scrollable locale="es-419" no-title @input="menuVencimiento = false" />
      </v-menu>
    </v-col>
    <datosCuotas :simbolo-moneda="simbolo" :cuota="cuotaInfo" :toggle="dialogCuota" class="mr-0 mt-0 pa-0" style="display: inline" />
  </v-card>
</template>

<script>
  // @change="enviarNuevoMonto"
  import datosCuotas from '../components/InformacionCuota'

  export default {
    name: 'Cuotas',
    components: {
      datosCuotas,
    },
    props: {
      cuota: {
        type: Object,
        required: false,
        default: null,
      },
      numero: {
        type: Number,
        default: 0,
      },
      value: {
        type: Number,
        default: 0,
      },
      cuotaId: {
        type: Number,
        default: 0,
      },
      saldo: {
        type: Number,
        default: 0,
      },
      fechaVencimiento: {
        type: String,
        default: '',
      },
      simbolo: {
        type: String,
        default: '$',
      },
      mode: {
        type: String,
        default: '',
      },
      condonar: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        menuVencimiento: false,
        dateVal: this.fechaVencimiento,
        pagadaParcialmente: false,
        seleccionada: false,
        dialogCuota: true,
        colorVerde: 'background-color: #ABFD99',
        colorAmarillo: 'background-color: #FDFD96',
        colorBlanco: 'color: "#ABFD99"',
        cuotaInfo: {
          moneda_id: 1,
        },
      }
    },
    computed: {
      inputVal: {
        get () {
          return this.value
        },
        set (val) {
          this.$emit('input', parseFloat(val, 10))
        },
      },
      canEdit () {
        return !(!this.pagadaParcialmente && this.saldo !== 0) || this.mode === 'show' || this.mode === 'prestamos'
      },
      estiloDerechos () {
        if (this.cuota.monto === this.cuota.monto_condonado) {
          return this.colorAmarillo
        }
        if (this.cuota.saldo === 0) {
          return this.colorVerde
        }
        return this.colorBlanco
      },
    },
    watch: {
      dateVal (val) {
        this.dateVal = val
        this.$emit('inputDate', val)
      },
      fechaVencimiento (val) {
        this.dateVal = val
      },
    },
    created () {
      this.pagadaParcialmente = (this.saldo !== this.value)
    },
    methods: {
      select () {
        const datoAcccion = {
          id: this.cuotaId,
          agregar: this.seleccionada,
        }
        this.$emit('selected', datoAcccion)
      },

      mostrarInfoCuota (Cuota, monedaId) {
        this.cuotaInfo = Cuota
        this.cuotaInfo.moneda_id = monedaId
        this.dialogCuota = !this.dialogCuota
      },
    },
  }
</script>
